/**
 * Header menu custom element.
 * Provides the wrapper element for the primary header nav; ref 'headerMenu' is used by header.js.
 */
if (!customElements.get('header-menu')) {
  customElements.define(
    'header-menu',
    class HeaderMenu extends HTMLElement {
      connectedCallback() {
        // Element exists for ref and layout; no extra behavior required
      }
    }
  );
}
